/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Calc_Row_ClickupInputs */

const en_mk_calc_row_clickup = /** @type {(inputs: Mk_Calc_Row_ClickupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ClickUp Business + Everything AI`)
};

const id_mk_calc_row_clickup = /** @type {(inputs: Mk_Calc_Row_ClickupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ClickUp Business + Everything AI`)
};

/**
* | output |
* | --- |
* | "ClickUp Business + Everything AI" |
*
* @param {Mk_Calc_Row_ClickupInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_calc_row_clickup = /** @type {((inputs?: Mk_Calc_Row_ClickupInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Calc_Row_ClickupInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_calc_row_clickup(inputs)
	return en_mk_calc_row_clickup(inputs)
});